import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const styles = stylex.create({
  row: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRadius: radii.small,
    paddingInline: spacing.space12,
    paddingBlock: spacing.space8,
    fontFamily: fonts.mono,
    fontSize: fontSizes.label,
    lineHeight: "18px",
    letterSpacing: "0.14px",
    color: colors.foreground,
    textDecoration: "none",
    backgroundColor: {
      default: "transparent",
      ":hover": colors.hover,
      ":focus-visible": colors.hover,
    },
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: -2,
  },
  league: {
    paddingLeft: 28,
    paddingBlock: spacing.space6,
    fontSize: fontSizes.small,
    lineHeight: "17px",
    color: colors.secondary,
  },
  current: { fontWeight: 600, color: colors.foreground },
  member: {
    marginLeft: spacing.space6,
    fontSize: fontSizes.caption,
    color: colors.muted,
  },
  browse: {
    marginTop: spacing.space4,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: colors.border,
    paddingTop: spacing.space12,
    color: colors.secondary,
  },
});
